import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=1547364e&"
import script from "./NavComponent.vue?vue&type=script&lang=js&"
export * from "./NavComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports